import React from 'react';
import styled from 'styled-components';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import media from 'styles/media';

export const InfoBox = styled.div`
  background: ${props => props.theme.infoColor};
  color: ${props => props.theme.smallFontColor};
  font-size: ${props => props.theme.fontSizePrimary};
  padding: 10px 15px;
  border-radius: 5px;
  margin: -5px 0 0.6em 0;
  ${media.extraSmallAndBelow`
    line-height: 1.3;
    padding: 6px 15px;
  `};
`;

const Small = styled.small`
  ${media.extraSmallAndBelow`
    font-size: 14px;
  `};
`;

export const AdditionalInfo = ({ infoGroup, className }) => {
  const filteredInfo = _filter(infoGroup, info => !!info);
  if (_isEmpty(filteredInfo)) {
    return null;
  }
  function createMarkup(text) {
    return { __html: text };
  }
  return (
    <InfoBox className={className}>
      {_map(infoGroup, (info, index) => <Small key={`infobox-small-${index}`} dangerouslySetInnerHTML={createMarkup(info)} />)}
    </InfoBox>
  );
};
